import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-sme-chat-lesson-create',
  templateUrl: './sme-chat-lesson-create.component.html',
  styleUrls: ['./sme-chat-lesson-create.component.scss'],
})
export class SMEChatLessonCreateComponent {
  @Output() create = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  form: FormGroup;

  lessonTypes = ['technical', 'management', 'software', 'others'];
  ynnaOptions = ['Y', 'N', 'NA'];

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      lessonTitle: ['', Validators.required],
      lessonInstructions: [''],
      lessonSubject: [''],
      lessonType: ['technical', Validators.required],
      lessonVersion: ['1.0'],
      lessonStatus: ['EMPTY'],
      lessonSlideCount: ['10', Validators.required],
      lessonLearnerProfile: ['New joinee'],
      lessonStyle: ['simple'],
      lessonContentMode: ['generic'],
      lessonDeliveredInPerson: ['N'],
      preferences: this.fb.group({
        lessonCaseStudy: ['NA'],
        lessonExamples: ['Y'],
        lessonAssessment: ['NA'],
        lessonSectionTOC: ['Y'],
        lessonQuizPerSection: [0],
        lessonQuizEndCount: [0],
        lessonQuizSimpleCount: [0],
        lessonQuizComplexCount: [0],
        lessonQuizAppliedFinalCount: [0],
      }),
      techpreferences: this.fb.group({
        lessonDerivations: ['NA'],
        lessonGoodPractices: ['NA'],
        lessonSafetyInstr: ['NA'],
        lessonIncludeStandards: ['NA'],
      }),
    });
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.create.emit(this.form.value);
  }
}

